// @core/api/endpoints/authn/terminate_sso_session.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TerminateSSOSessionRequest,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Terminate SSO session
 * Ends a specific SSO session, logging the user out of all applications using that session. May trigger single logout callbacks to connected applications.
 */
export async function TerminateSSOSession(
  session_id: string,
  data: TerminateSSOSessionRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/oauth2/sso/sessions/:session_id/terminate`;
  requestPath = requestPath.replace(':session_id', encodeURIComponent(session_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
